import { ApiResponse } from '@models/common/api';
import { IGetRankingAnalyticsResponse, IGridReportItem } from '@models/location/response';

import { post, get } from './methods';

const BASE_ENDPOINT = 'locations';

const rankingAPI = {
  addKeywords: async (locationId: number) => {
    const response = await post<ApiResponse<unknown>>(`${BASE_ENDPOINT}/${locationId}/keywords`);
    return response.data;
  },

  getRankingAnalytics: async (locationId: number) => {
    const response = await get<ApiResponse<IGetRankingAnalyticsResponse>>(`${BASE_ENDPOINT}/${locationId}/keywords`);
    return response.data;
  },

  getLocalGridReport: async (locationId: number) => {
    const response = await get<ApiResponse<IGridReportItem[]>>(`${BASE_ENDPOINT}/${locationId}/local-grid/reports`);
    return response.data;
  },

  generateLocalGridReport: async (locationId: number) => {
    const response = await post<ApiResponse<IGridReportItem[]>>(`${BASE_ENDPOINT}/${locationId}/local-grid/reports`);
    return response.data;
  },
};

export default rankingAPI;
